<template>
    <div>
        <EChart
            :options="chartOptions"
            card
            :header="$t('numberOfOffers')"
            :loading="loading"
            :tooltip="$t('chartHeaderTooltip')"
            class="shadow-none m-0"
            @click="handleChartClick"
        />
        <ModalNumberOfOffersItem />
    </div>
</template>



<script>
    import EChart from '@/components/common/EChart.vue';
    import ModalNumberOfOffersItem from './ModalNumberOfOffersItem.vue';

    export default {
        name: 'NumberOfOffers',
        components: {
            EChart,
            ModalNumberOfOffersItem,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestReportSet: this.parentComponent.requestReportSet,
                requestReport: this.parentComponent.requestReport,
            };
        },
        computed: {
            loading() {
                return this.parentComponent.loading;
            },
            currentItem() {
                return this.parentComponent.currentItem;
            },
            productSet() {
                return this.parentComponent.productSet;
            },
            currentSet() {
                if (!this.currentItem?.reportId) return null;
                return (this.productSet || []).find(setEntry => setEntry.reportId === this.currentItem.reportId) || null;
            },
            productsInSet() {
                return this.currentSet?.allProducts || [];
            },
            chartOptions() {
                if (!this.productsInSet.length) return { series: [] };

                // wyliczamy oferty dla produktów w bieżącym secie
                const rows = this.productsInSet.map(productMeta => this.parentComponent.getDataForSet(this.productsInSet, productMeta.id, productMeta.type)).filter(Boolean);

                if (!rows.length) return { series: [] };

                // Sort rosnąco po liczbie ofert
                rows.sort((a, b) => (a.offersNumber || 0) - (b.offersNumber || 0));

                const yAxisData = rows.map(item => ({ value: item.name, metaData: item }));
                const offersData = rows.map(item => item.offersNumber || 0);

                return {
                    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
                    xAxis: { type: 'value' },
                    yAxis: {
                        type: 'category',
                        data: yAxisData,
                        axisLabel: {
                            formatter: val => ` {btn|»}${val}`,
                        },
                        triggerEvent: true,
                    },
                    series: [
                        {
                            type: 'bar',
                            data: offersData,
                            label: { show: true, position: 'insideLeft' },
                        },
                    ],
                    legend: { show: false },
                };
            },
        },
        methods: {
            handleChartClick(params) {
                if (params.componentType === 'yAxis') {
                    const item = this.chartOptions.yAxis.data[params.dataIndex].metaData;
                    this.showDetails(item);
                }
            },
            showDetails(item) {
                const id = 'ModalNumberOfOffersItem';
                this.$root.$emit('bv::show::modal', id);
                this.$root.$emit(id, item);
            },
        },
    };
</script>



<i18n lang="json" locale="pl" scope="local">
{
    "chartHeaderTooltip": "Ranking pod względem liczby dostępnych ofert w sklepach dla produktu."
}
</i18n>

<i18n lang="json" locale="en" scope="local">
{
    "chartHeaderTooltip": "he ranking by the number of available offers in stores for the product."
}
</i18n>

